export const setLink = (link) => async (dispatch) => {

    try {
        dispatch({
            type: 'SET_LINK',
            payload: link,
        })

    } catch (error) {

        return error

    }
}

export const setFinalLink = (finallink) => async (dispatch) => {

    try {
        dispatch({
            type: 'SET_FINAL_LINK',
            payload: finallink,
        })

    } catch (error) {

        return error

    }
}